import React, { useState, useEffect, Fragment } from 'react';
import { Row, Card, CardBody, Input, CustomInput } from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getUserID } from '../../../../../helpers/AxiosAPI';
import {
  gAPI_Groups,
  gAPI_CheckUser_Groups,
} from '../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import CreateGroupsForm from './components/forms/CreateGroupsForm';
import UpdateGroupsForm from './components/forms/UpdateGroupsForm';
import DetailButton from './components/forms/DetailButton';

function Index({ propertyId, history }) {
  const [groupList, setGroupsList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showApprovalGroups, setShowApprovalGroups] = useState(false);

  useEffect(() => {
    LoadGroups();
  }, [propertyId]);

  const LoadGroups = () => {
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_CheckUser_Groups}/${getUserID()}`,
    })
      .then((res) => {
        AxiosAPI({
          methhod: 'get',
          url: `${gAPI_Groups}`,
        })
          .then((res) => {
            setGroupsList(res.data);
            setLoading(false);
          })
          .catch((err) => console.log('err', err));
      })
      .catch((err) => history.push('/app/error'));
  };

  if (loading) {
    return (
      <Card className="d-flex flex-row mb-3">
        <CardBody>
          <h4 style={{ textAlign: 'center' }}>Loading...</h4>
        </CardBody>
      </Card>
    );
  }

  return (
    <Fragment>
      <Row className="mb-3">
        <Colxx xxs="12">
          <CustomInput
            type="checkbox"
            checked={showApprovalGroups}
            onClick={() => {
              setShowApprovalGroups(!showApprovalGroups);
            }}
            label="Show Groups Pending for Approval"
          ></CustomInput>
        </Colxx>
      </Row>
      <Row>
        {groupList.map((group, index) => (
          <Colxx xxs="12" key={index}>
            {showApprovalGroups === true &&
            group.status === 'PendingApproval' ? (
              <Card className="d-flex flex-row mb-3">
                <div className="pl-2 d-flex flex-grow-1 min-width-zero">
                  <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
                    <p className="mb-1  text-small w-50 w-sm-100">
                      <b>{group.name}</b>
                    </p>
                    <p className="mb-1  text-small w-50 w-sm-100">
                      {group.groupId}
                    </p>
                    <p className="mb-1  text-small w-25 w-sm-100">
                      {group.status}
                    </p>
                    <p className="mb-1  text-small w-25 w-sm-100">
                      {group.country}
                    </p>
                    <div className="w-15 w-sm-100">
                      <UpdateGroupsForm id={group.groupId} />
                    </div>
                    <div className="w-15 w-sm-100">
                      <DetailButton
                        id={group.groupId}
                        LoadGroups={LoadGroups}
                      />
                    </div>
                  </div>
                </div>
              </Card>
            ) : null}

            {showApprovalGroups === false &&
            group.status !== 'PendingApproval' ? (
              <Card className="d-flex flex-row mb-3">
                <div className="pl-2 d-flex flex-grow-1 min-width-zero">
                  <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
                    <p className="mb-1  text-small w-50 w-sm-100">
                      <b>{group.name}</b>
                    </p>
                    <p className="mb-1  text-small w-50 w-sm-100">
                      {group.groupId}
                    </p>
                    <p className="mb-1  text-small w-25 w-sm-100">
                      {group.status}
                    </p>
                    <p className="mb-1  text-small w-25 w-sm-100">
                      {group.country}
                    </p>
                    <div className="w-15 w-sm-100">
                      <UpdateGroupsForm id={group.groupId} />
                    </div>
                  </div>
                </div>
              </Card>
            ) : null}
          </Colxx>
        ))}
      </Row>
      <CreateGroupsForm />
    </Fragment>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, userId } = settings;
  return {
    propertyId,
  };
};

export default injectIntl(connect(mapStateToProps, {})(Index));
